import AlertConfigs from "./AlertConfigs";
import Identity from "./Identity";

// TODO: This info should be pulled from an API and not defined locally.
import logoGeollect from "./_assets/GeollectBannerLogoWhite2.png"; // "./_assets/GeoniusBannerWordmark2.png";
import logoLondon from "./_assets/LondonBannerLogoWhite.png";
import logoStandard from "./_assets/StandardBannerLogoWhite.png";
import logoIlluminate from "./_assets/vigilance_maritime.png";
import logoWest from "./_assets/WestBannerLogo.png";

import faviconGeollect from "./_assets/GeoniusFavicon.png";
import faviconLondon from "./_assets/LondonFavicon.png";
import faviconStandard from "./_assets/StandardFavicon.png";
import faviconWest from "./_assets/WestFavicon.png";
const IDGeollect = new Identity({
	name: "Geollect",
	logo: logoGeollect,
	favicon: faviconGeollect,
	alertConfigs: AlertConfigs.geollect
});
const IDWest = new Identity({ name: "West", logo: logoWest, favicon: faviconWest, alertConfigs: AlertConfigs.west });
const IDStandard = new Identity({
	name: "Standard",
	logo: logoStandard,
	favicon: faviconStandard,
	alertConfigs: AlertConfigs.standard
});
const IDLondon = new Identity({
	name: "London P&I",
	logo: logoLondon,
	favicon: faviconLondon,
	alertConfigs: AlertConfigs.london
});
const IDBorderForce = new Identity({
	name: "Border Force",
	logo: logoGeollect,
	favicon: faviconGeollect,
	alertConfigs: AlertConfigs.border_force
});

// const IDBritNed = new Identity({
// 	name: "BritNed",
// 	logo: logoBritned,
// 	favicon: faviconGeollect,
// 	alertConfigs: AlertConfigs.geollect,
// });

const IDTdiBrooks = new Identity({
	name: "Geollect",
	logo: logoGeollect,
	favicon: faviconGeollect,
	alertConfigs: AlertConfigs.tdi_brooks
});
const IDOneIlluminate = new Identity({
	name: "Geollect",
	logo: logoIlluminate,
	favicon: faviconGeollect,
	alertConfigs: AlertConfigs.geollect,
});
const IdentityData = {
	geollect: IDGeollect,
	west: IDWest,
	standard: IDStandard,
	london: IDLondon,
	tdi_brooks: IDTdiBrooks,
	"border force": IDBorderForce,
	// "national grid": IDBritNed,
	one_illuminate: IDOneIlluminate,
};

export default IdentityData;
